export default __webpack_public_path__ + "static/media/user.bfab0fad.svg";